module.exports = __webpack_public_path__ + "media/images/mbd-dashboard-0b2a00e3b574358c88ed308f2f5aa6a8.webp";